"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyEmailContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.legacyEmailContract = c.router({
    legacyEmailRedirect: {
        method: 'GET',
        path: '/open-link',
        query: zod_1.z.object({
            link: zod_1.z.string().optional(),
        }),
        responses: {
            301: zod_1.z.undefined(),
        },
    },
});
//# sourceMappingURL=email.legacy.contract.js.map